export const formatPayload = (formState: any): any => {
    return {
        current_password: formState[0]?.value,
        new_password: formState[1]?.value,
        repeat_password: formState[2]?.value,
    };
};
